import { useEffect } from "react";

export function useJsonLd(id: string, data: Record<string, unknown> | null) {
  useEffect(() => {
    if (!data) return undefined;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [id, data]);
}